/* eslint guard-for-in:0 */
/* global PortalL10n */

/**
 * PortalElementFieldSearch
 */

const {log, error} = require('./PortalLogging')
const PortalApi = require('./PortalApi')
const PortalElementSearch = require('./PortalElementSearch')
const PortalEvent = require('./PortalEvent')
const {l10n} = require('./PortalL10n')

const props = [
  'el'
]

const translateFields = {
  "objekte._nested:objekte__obj_autoren.obj_autor_gnd.conceptName" : "author_gnd",
  "objekte._nested:objekte__obj_autoren_lok.obj_autor_lok._standard.1.text" : "author_lok",
  "objekte._nested:objekte__obj_provenienz._nested:objekte__obj_provenienz__obj_provenienzen_gnd.obj_provenienz_gnd.conceptName": "provenance"
}
// swap keys and values
const untranslateFields =
  Object.fromEntries(
    Object.entries(translateFields).map(([k, v]) => [v, k])
  )

module.exports = class PortalElementFieldSearch extends PortalElementSearch {
  constructor(opts={}) {
    props.forEach(prop => {if (opts[prop] === undefined) throw new Error(`Missing required prop "${prop}" for PortalElementFieldSearch`)})

    log("new PortalElementFieldSearch", opts)

    super(opts)
    Object.assign(this, {})

    this.searchFields = []
    // check if there are any search fields in the query string
    // if a translated field name appears (such as "author"), translate it back to the name used
    // to search the easydb (such as "objekte._nested:objekte__obj_autoren.obj_autor_gnd.conceptName")
    let searchParams = new URLSearchParams(window.location.search)
    for (const [key, value] of searchParams.entries()) {
      let translatedKey = untranslateFields[key] !== undefined ? untranslateFields[key] : key
      if (translatedKey == "_system_object_id") {
       this.searchFields.push({"field": translatedKey, "term": parseInt(value)})
      } else {
       this.searchFields.push({"field": translatedKey, "term": value})
      }
    }

    // Select the search fields obtained from the query string in the search options and input options
    this.searchFields.forEach((search_param, ind) => {
      let selector_finder_string = `select[name='search-option_${ind}']`;
      let selector_element = $(this.target).find(selector_finder_string);
      if (selector_element.length) {
        for (let i=0; i<selector_element[0].options.length; i++) {
          if (selector_element[0].options[i].value.split(";").includes(search_param["field"])) {
            selector_element[0].selectedIndex = i;
          }
        }
      }
      let input_finder_string = `input[name='search-input_${ind}']`;
      let input_element = $(this.target).find(input_finder_string);
      if (input_element.length) {
        input_element[0].value = search_param["term"];
      }
    })

    // emit search on first load such that all results are shown (when query string is empty)
    this.searchFromForm(true)
    // PortalEvent.emit('newSearch',this.target)

    // Autocomplete
    $(this.target).find('[data-function="ep-query"]').each((i,el) => {
      $(el).autoComplete({
        minChars: 2,
        cache: false,
        source: (term, response) => {
          let words = term.split(/ +/)
          let searchterm = words.pop()
          let field = $(el).closest('fieldset').find('[data-function="ep-search-field"]').eq(0).val()
          let suggestRequest = this.buildSuggestRequest(field,searchterm)
          this.suggest(suggestRequest)
            .then(data => {
              let matches = data.suggestions.tokens.map(item => {
                let v = words.join(' ')
                if (v.length) {v += ' '}
                v += item.tokens[0]
                return v
              })
              let matches_linked_objects = data.suggestions.linked_objects.map(item => {
                let v = words.join(' ')
                if (v.length) {v += ' '}
                v += item['_standard']['1']['text']['de-DE']
                return v
              })
              response(matches)
            })
            .catch(error => {response([])})
        }
      })
    })

    this.setUpUserProfileData();

  }

  init() {}

  searchFromForm(keepSearchFields) {
    // TODO: Breakdown this method
    let error = ''

    this.searchOptionsFromForm(keepSearchFields)

    // Suchfelder einlesen
    // Read in search fields
    if (!keepSearchFields) {
      this.searchFields = []
    }
    $(this.target).find('[data-function="ep-query"]').each((i,el) => {
      if ($(el).val().trim().length) {
        let field = $(el).closest(".flex-container").find('[data-function="ep-search-field"]').eq(0).val()
        let searchtype = 'term'
        if (field.match(/^string:/)) {
          searchtype = 'string'
          field = field.substring(7)
        }
        if (searchtype == 'string') {
          this.searchFields.push({"field": field, "term": $(el).val().trim()})
        }
        else {
          $(el).val().trim().split(/ +/).forEach(t => {
            if (field == '_system_object_id') {
              if (!t.match(/^\d+$/)) {error = 'System-ID muss Zahl sein'}
              else {this.searchFields.push({"field": field, "term": parseInt(t)})}
            }
            else {
              this.searchFields.push({"field": field, "term": t})
            }
          })
        }
      }
    })

    // console.log("searchFields before executing :")
    // console.log(this.searchFields)

    // update query string with current search fields
    let newQueryStringList = []

    // translate search fields so they are short and understandable in the query string
    for (const searchField of this.searchFields) {
      let field;
      let term;
      for (const [key, value] of Object.entries(searchField)) {
        if (key == "field") {
          field = translateFields[value] !== undefined ? translateFields[value] : value;
        }
        if (key == "term") {
          term = value;
        }
      }
      newQueryStringList.push(`${field}=${encodeURIComponent(term)}`)
    }

    // build new query string from search fields and append to URL (or replace the old one)
    // console.log("list of new query strings:")
    // console.log(newQueryStringList)
    // console.log(`new query string: ${newQueryStringList.join('&')}`)

    let newQueryString = newQueryStringList.length > 0 ? `?${newQueryStringList.join('&')}` : ""
    if (window.location.search !== newQueryString) {
      history.pushState(null, null, `${window.location.href.split('?')[0]}${newQueryString}`);
    }

    let searchRequest = this.buildSearchRequest()

    // store base search request
    //PortalStorage.setItem('local','searchRequest', searchRequest)

    if (error) {alert(error)}
    else {this.search(searchRequest)}
  }

  setUpUserProfileData() {
    let userDisplayName = PortalStorage.getUserDisplayNameFromCookies();
    let token = PortalStorage.getTokenFromCookies();
    if (token && userDisplayName && userDisplayName != 'anonymous') {
      $("#login-register-containers").addClass("hidden");
      $(".user-name-container").removeClass("hidden");
      $(".userDisplayName").text(userDisplayName);
    } else {
      $(".user-name-container").addClass("hidden");
      $("#login-register-containers").removeClass("hidden");
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./js/PortalElementFieldSearch.js
// module id = 20
// module chunks = 0